import { PhoneCall } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES, scrollToId } from "../../lib/site";

export const CtaBand = () => (
    <section data-testid="intermediate-cta-band" className="relative overflow-hidden py-28 lg:py-40">
        <img
            src={IMAGES.band}
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/85" />
        <div
            className="pointer-events-none absolute right-0 top-0 h-[420px] w-[420px] rounded-full opacity-20"
            style={{ background: "radial-gradient(circle, #FF5722 0%, transparent 65%)" }}
        />
        <div className="relative z-10 mx-auto max-w-3xl px-5 text-center">
            <Reveal>
                <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                    Vous ne savez pas exactement quel matériel ou quelle solution choisir ?
                </h2>
                <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-zinc-300 sm:text-lg">
                    Expliquez simplement votre chantier à notre équipe. Nous étudierons avec vous
                    la solution adaptée à votre besoin.
                </p>
                <button
                    type="button"
                    data-testid="intermediate-cta-button"
                    onClick={() => scrollToId("besoin")}
                    className="mt-9 inline-flex items-center gap-2 rounded-full bg-signal px-8 py-4 text-base font-bold text-ink transition-colors hover:bg-signal-dark"
                >
                    <PhoneCall className="h-5 w-5" />
                    Être rappelé
                </button>
            </Reveal>
        </div>
    </section>
);
